import { useIntl } from 'react-intl';
import { Badge, Tab, Tabs } from '@material-ui/core';
import { OrderGroup } from './utils';

interface OrderGroupTabsProps {
  groups: OrderGroup[];
  value: OrderGroup | null;
  // Shown as a badge on the Waiting tab when positive.
  pendingCount: number | null;
  onChange: (group: OrderGroup) => void;
}

// Status tabs of the work order lists. My work orders and All work orders
// share the groups and their labels, so both show the same orders per tab.
const OrderGroupTabs = ({
  groups,
  value,
  pendingCount,
  onChange,
}: OrderGroupTabsProps) => {
  const intl = useIntl();
  return (
    <Tabs
      value={value || false}
      onChange={(_event, next: OrderGroup) => onChange(next)}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      aria-label={intl.formatMessage({ id: 'MY_ORDERS.GROUPS' })}
    >
      {groups.map((group) => {
        const label = intl.formatMessage({
          id: `MY_ORDERS.GROUP.${group.toUpperCase()}`,
        });
        return (
          <Tab
            key={group}
            value={group}
            label={
              group === 'pending' && pendingCount ? (
                <Badge
                  color="secondary"
                  badgeContent={pendingCount}
                  style={{ paddingRight: 12 }}
                >
                  {label}
                </Badge>
              ) : (
                label
              )
            }
          />
        );
      })}
    </Tabs>
  );
};

export default OrderGroupTabs;
